import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  HtmlEditorModule,
  PageHeaderModule,
  SmartTableModule,
  TextareaModule,
  TextInputModule,
} from '@certemy/ui-components';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { CategoryEditRepeaterComponent } from './category-edit-repeater.component';

@NgModule({
  declarations: [CategoryEditRepeaterComponent],
  imports: [
    CertemyCommonModule,
    PageHeaderModule,
    ReactiveFormsModule,
    TextareaModule,
    TextInputModule,
    SmartTableModule,
    HtmlEditorModule,
  ],
  exports: [CategoryEditRepeaterComponent],
})
export class CategoryEditRepeaterModule {}
